import React, { useState } from 'react';
import Navbar from './components/navbar';
import NavigationPane from './components/navigationpane';
import Footer from './components/footer';
import DbMigration from './components/dbMigration';
import Nosql from './components/Nosql';
import { CssBaseline, Toolbar, Divider, Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './components/theme';
import Scheduler from './components/scheduler';
import Documentation from './components/Documentation';
import Tuning from './components/Tuning';
import TestScript from './components/testscript';
import TestData from './components/testdata';
import RdbmsToNosql from './components/RdbmsToNosql';
import RdbmsToRdbms from './components/RdbmsToRdbms';
import DQ from './components/DQ';
import DDL from './components/DDL';
import PLSQL from './components/PLSQL';
import Chatbot from './components/chatbot';
import InformaticaPy from './components/Informatica-Py';

const App = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [showAdditionalOptions, setShowAdditionalOptions] = useState(false);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden' }}>
        <CssBaseline />
        <Navbar />
        <Box sx={{ width: '100%', position: 'fixed', top: '64px', left: 0, zIndex: 1300 }}>
          <Divider sx={{ backgroundColor: 'rgba(249, 199, 5, 1)', height: '0.7vh', }} />
        </Box>
        <div style={{ display: 'flex', flexGrow: 1, marginTop: '64px', marginBottom: '40px', overflowX: 'hidden' }}>
          <NavigationPane
            selectedOption={selectedOption}
            setShowAdditionalOptions={setShowAdditionalOptions}
            onOptionClick={handleOptionClick}
          />
          <main style={{ flexGrow: 1, padding: '24px', marginLeft: '60px', marginRight: '60px', overflowX: 'hidden' }}>
            <Toolbar />

            {selectedOption === 'NoSQL -> RDBMS' && <Nosql />}
            {selectedOption === 'RDBMS -> NoSQL' && <RdbmsToNosql />}
            {selectedOption === 'RDBMS -> RDBMS' && <RdbmsToRdbms />}
            {selectedOption === 'Migration' && <DbMigration setShowAdditionalOptions={setShowAdditionalOptions} />}
            {selectedOption === 'Scheduler' && <Scheduler />}
            {selectedOption === 'Test Script Generation' && <TestScript />}
            {selectedOption === 'Test Data Generation' && <TestData />}
            {selectedOption === 'Documentation' && <Documentation />}
            {selectedOption === 'Tuning and Suggestions' && <Tuning />}
            {selectedOption === 'Data Quality' && <DQ />}
            {selectedOption === 'Data Model & DDL' && <DDL />}
            {selectedOption === 'SQL, PL/SQL' && <PLSQL />}
            {selectedOption === 'Informatica -> Python/Pyspark' && <InformaticaPy />}
            {selectedOption === 'Elevate Bot' && <Chatbot />}
          </main>
        </div>
        <Box sx={{ width: '100%', position: 'fixed', bottom: '7vh', left: 0, zIndex: 1300 }}>
          <Divider sx={{ backgroundColor: 'rgba(249, 199, 5, 1)', height: '0.7vh', }} />
        </Box>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default App;